import { apiPATCH } from './api';

export const modifyPickupSpecs = (id, data) => {
  return apiPATCH(`/pickup_specs/${id}`, data);
};
